import { render, staticRenderFns } from "./OrderApi.vue?vue&type=template&id=536157b5&scoped=true&"
import script from "./OrderApi.vue?vue&type=script&lang=js&"
export * from "./OrderApi.vue?vue&type=script&lang=js&"
import style0 from "./OrderApi.vue?vue&type=style&index=0&id=536157b5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "536157b5",
  null
  
)

export default component.exports